var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3346 15.1668H22.0013C20.0564 15.1668 18.1911 15.9394 16.8159 17.3147C15.4406 18.69 14.668 20.5552 14.668 22.5002V59.1668M14.668 59.1668V66.5002C14.668 68.4451 15.4406 70.3103 16.8159 71.6856C18.1911 73.0609 20.0564 73.8335 22.0013 73.8335H66.0013C67.9462 73.8335 69.8115 73.0609 71.1868 71.6856C72.562 70.3103 73.3346 68.4451 73.3346 66.5002V51.8335M14.668 59.1668L31.4833 42.3515C32.8585 40.9767 34.7234 40.2044 36.668 40.2044C38.6125 40.2044 40.4774 40.9767 41.8526 42.3515L51.3346 51.8335M73.3346 37.1668V51.8335M73.3346 51.8335L67.5193 46.0182C66.1441 44.6434 64.2792 43.8711 62.3346 43.8711C60.3901 43.8711 58.5252 44.6434 57.15 46.0182L51.3346 51.8335M51.3346 51.8335L58.668 59.1668M66.0013 15.1668H80.668M73.3346 7.8335V22.5002M51.3346 29.8335H51.3713",
    stroke: "#00BA6C",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimage);
export default __webpack_public_path__ + "static/media/Add image.2a5da83c9697e7beed4e5821dd22ce07.svg";
export { ForwardRef as ReactComponent };